<template>
  <div class="pb-3" >
    <va-card id="card-principal" :title="$t(`videos.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12" id="erro">
            </div>
            <div class="flex md12">
              <div v-if='oldThumbnail.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/thumbnail-video/' + oldThumbnail"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Logo" :rules="oldThumbnail.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('videos.forms.thumbnailLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="thumbnail"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <div v-if='oldFile.length > 0' class="form-group mt-3">
                <video style="height: 30vh; max-width: 100%;" controls>
                  <source :src="$store.getters['environment/cdn'] + '/video/' + oldFile">
                </video>
              </div>
              <ValidationProvider name="Video" :rules="oldFile.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('videos.forms.fileLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="file"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" name="Título" v-slot="{ errors }">
                <va-input
                  v-model="video.title"
                  :label="$t('videos.forms.titleLabel')"
                  :placeholder="$t('videos.forms.titlePlaceholder')"
                  :success="errors.length == 0 && video.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <div
        id="spinner"
        class="spinner-hidden"
      >
        <OrbitSpinner
          :animation-duration="1500"
          :color="'#e34b4a'"
          :size="100"
        />
      </div>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ErrorMessages from '../utils/ErrorMessages'
import { OrbitSpinner } from 'epic-spinners'
export default {
  name: 'VideosAddUpdate',
  components: {
    ErrorMessages,
    OrbitSpinner,
  },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      video: {
        file: '',
        title: '',
        thumbnail: '',
      },
      oldThumbnail: '',
      oldFile: '',
      thumbnail: [],
      file: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  mounted () {
    this.video.title = ''
    this.video.file = ''
    this.video.thumbnail = ''
    if (this.updateData !== null) {
      this.video_get(this.updateData)
    }
  },
  watch: {
    thumbnail (value) {
      if (value.length > 0) {
        this.video.thumbnail = value[0].name
      }
    },
    file (value) {
      if (value.length > 0) {
        this.video.file = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.video_get(this.updateData)
      } else {
        this.video.file = ''
        this.video.thumbnail = ''
        this.video.title = ''
      }
    },
  },
  methods: {
    erro (err) {
      document.getElementById('erro').innerHTML = '<div class="va-notification" style="background: rgba(248, 112, 109, 0.2); box-shadow: rgba(248, 112, 109, 0.6) 0px 0.125rem 0.125rem 0px;">' +
      '  <div class="va-notification__content">' +
      '      <div class="va-badge mr-2" style="color: rgb(255, 255, 255); border-color: rgb(248, 112, 109); background-color: rgb(248, 112, 109);">' +
      '        <div class="va-badge__content d-flex">' +
      '            <div class="va-badge__content__title flex-center">Erro</div>' +
      '        </div>' +
      '      </div>' +
            err +
      '  </div>' +
      '  <div class="va-notification__close-icon"><i class="va-icon ion-md-close ion" style="color: rgb(248, 112, 109);"></i></div>' +
      '</div>'
    },
    closeSpinner () {
      var opacity = document.getElementById('card-principal')
      opacity.classList.remove('opacity-submit')
      var spinner = document.getElementById('spinner')
      spinner.classList.remove('spinner')
      spinner.classList.add('spinner-hidden')
    },
    openSpinner () {
      var opacity = document.getElementById('card-principal')
      opacity.classList.add('opacity-submit')
      var spinner = document.getElementById('spinner')
      spinner.classList.add('spinner')
      spinner.classList.remove('spinner-hidden')
    },
    cancel () {
      this.$emit('showAdd', false)
    },
    video_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value === 'thumbnail') {
          this.oldThumbnail = data[value]
          this.video[value] = ''
        } else if (value === 'file') {
          this.oldFile = data[value]
          this.video[value] = ''
        } else if (value !== '__typename') {
          this.video[value] = data[value]
        }
      })
    },
    async upload () {
      this.openSpinner()
      if (this.video.thumbnail.length !== 0 && this.video.file.length !== 0) {
        let erro = false
        let formData = new FormData()
        formData.append('file', this.thumbnail[0])
        formData.append('path', 'thumbnail-video')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldThumbnail)
        }
        const upImage = this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.video.thumbnail = resp.data.filename
        }).catch(err => {
          erro = true
          this.erro(err + ' ' + err.response.status)
        })
        formData = new FormData()
        formData.append('file', this.file[0])
        formData.append('path', 'video')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldFile)
        }
        const upVideo = this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.video.file = resp.data.filename
        }).catch(err => {
          erro = true
          this.erro(err + ' ' + err.response.status)
        })
        await upImage
        await upVideo
        if (!erro) {
          this.onSubmit()
        } else {
          this.closeSpinner()
        }
      } else if (this.video.id !== null) {
        let erro = false
        if (this.video.thumbnail.length !== 0 && !erro) {
          const formData = new FormData()
          formData.append('file', this.thumbnail[0])
          formData.append('path', 'thumbnail-video')
          if (this.updateData !== null) {
            formData.append('deleteFile', this.oldThumbnail)
          }
          await this.$axios.post(
            '/api/upload',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            },
          ).then(resp => {
            this.video.thumbnail = resp.data.filename
          }).catch(err => {
            erro = true
            this.erro(err + ' ' + err.response.status)
          })
        } else {
          this.video.thumbnail = this.oldThumbnail
        }
        if (this.video.file.length !== 0 && !erro) {
          const formData = new FormData()
          formData.append('file', this.file[0])
          formData.append('path', 'video')
          if (this.updateData !== null) {
            formData.append('deleteFile', this.oldFile)
          }
          await this.$axios.post(
            '/api/upload',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            },
          ).then(resp => {
            this.video.file = resp.data.filename
          }).catch(err => {
            erro = true
            this.erro(err + ' ' + err.response.status)
          })
        } else {
          this.video.file = this.oldFile
        }
        if (!erro) {
          this.onSubmit()
        } else {
          this.closeSpinner()
        }
      } else {
        this.video.thumbnail = this.oldThumbnail
        this.video.file = this.oldFile
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { file, title, thumbnail } = this.video
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($file: String!, $title: String!, $id: Int!, $thumbnail: String!) {
                  update_video_by_pk(pk_columns: {id: $id}, _set: {file: $file, title: $title, thumbnail: $thumbnail}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($file: String, $title: String!, $thumbnail: String!) {
                  insert_video(objects: {file: $file, title: $title, thumbnail: $thumbnail}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            file,
            title,
            thumbnail,
            id: this.video.id,
          } : {
            file,
            thumbnail,
            title,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.video.file = ''
          self.video.title = ''
          self.video.thumbnail = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(err => {
          this.closeSpinner()
          this.erro(err)
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}

.opacity-submit {
  opacity: 0.6;
}

.spinner {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.spinner-hidden {
  display: none;
}
</style>
